import { loadPinmap } from './abTest'
import companyApiInstance from './companyApiInstance'
import { iframeLoadedShopify, iframeLoadedWoocommerceVtex } from './iframeLoadedCmsHelper'
import { companyInfoAvailable, getUserInfoLocalStorage, isLocalStorageAvailable, setCompanyLocalStorage } from './localStorage'
import { decryptToken, getPinflagApiKey } from './utils'

export const getCompanyInfoHelper = (setUserInfo, setCompanyInfo) => {
  const preloadUserInfo = () => {
    setUserInfo(prevState => ({
      ...prevState,
      ...getUserInfoLocalStorage()
    }))
  }

  const pinflagApiKey = getPinflagApiKey()
  preloadUserInfo()
  if (isLocalStorageAvailable()) {
    const companyLocalStorage = companyInfoAvailable(pinflagApiKey)
    if (companyLocalStorage) {
      iframeLoadedShopify(loadPinmap(companyLocalStorage.checkout))
      iframeLoadedWoocommerceVtex(loadPinmap(companyLocalStorage.checkout))
      return setCompanyInfo((prevState) => {
        return {
          ...prevState,
          ...companyLocalStorage,
          mapboxToken: (companyLocalStorage.mapboxToken && !['null', 'undefined'].includes(companyLocalStorage.mapboxToken)) ? companyLocalStorage.mapboxToken : process.env.REACT_APP_MAPBOX_TOKEN
        }
      })
    }
  }
  if (pinflagApiKey) {
    companyApiInstance(pinflagApiKey)
      .get('/company/personalization', {
        cache: {
          maxAge: 5 * 60 * 1000, // override default cache duration for this request
          exclude: { query: false } // don't include query parameters in cache key
        }
      })
      .then((res) => {
        iframeLoadedShopify(loadPinmap(res.data.checkout))
        iframeLoadedWoocommerceVtex(loadPinmap(res.data.checkout))
        let labelPricePickup = res.data.storePickupPriceLabel
        if (!isNaN(parseInt(res.data.storePickupPriceLabel))) labelPricePickup = '$' + res.data.storePickupPriceLabel
        const companyObject = {
          logoUrl: res.data.logoUrl,
          primaryColor: res.data.primaryColor || '#394860',
          secondaryColor: res.data.secondaryColor || '#00B7F9',
          companyName: res.data.company.nombreempresa,
          userId: res.data.company.userId,
          pinflagApiKey,
          ccDiscountPercentageLabel: res.data.ccDiscountPercentageLabel,
          storePickupPriceLabel: labelPricePickup,
          storePickupTypeLabel: res.data.storePickupTypeLabel,
          checkout: res.data.checkout,
          useBillingData: res.data.useBillingData,
          useSsn: res.data.useSsn,
          useDiscountCode: res.data.useDiscountCode,
          useGiftCard: res.data.useGiftCard,
          mapboxToken: decryptToken(res.data.mapboxToken, process.env.REACT_APP_TOKEN_ENCRYPTATION_KEY) || process.env.REACT_APP_MAPBOX_TOKEN,
          usePixelEvents: res.data.usePixelEvents
        }
        isLocalStorageAvailable() && setCompanyLocalStorage(companyObject)
        return setCompanyInfo((prevState) => {
          return {
            ...prevState,
            ...companyObject
          }
        })
      })
      .catch((err) => {
        iframeLoadedShopify(false)
        iframeLoadedWoocommerceVtex(false)
        setCompanyInfo((prevState) => {
          return {
            ...prevState,
            pinflagApiKey
          }
        })
        console.error(err)
      })
  }
}
